import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '../../../shared/shared.module';
import { TabsModule } from '../../../tabs/tabs.module';

import { UpdoxMessagingComponent } from './updox-messaging.component';
import { UpdoxFolderListComponent } from './folder-list/folder-list.component';
import { UpdoxMessageListComponent } from './message-list/message-list.component';
import { UpdoxMessageDetailComponent } from './message-detail/message-detail.component';
import { UpdoxContactsComponent } from './contacts/contacts.component';
import { UpdoxAttachmentsComponent } from './attachments/attachments.component';
import { UpdoxCcdaPreviewComponent } from './ccda-preview/ccda-preview.component';
import { MedicationSummaryModule } from '../../../health/patient-profile/patient-dashboard/summary/medication-summary/medication-summary.module';

@NgModule({
  declarations: [
    UpdoxMessagingComponent,
    UpdoxFolderListComponent,
    UpdoxMessageListComponent,
    UpdoxMessageDetailComponent,
    UpdoxContactsComponent,
    UpdoxAttachmentsComponent,
    UpdoxCcdaPreviewComponent,
  ],
  exports: [
    UpdoxMessagingComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    TabsModule,
    MedicationSummaryModule,
  ],
})
export class UpdoxMessagingModule {}
